import { ref } from 'vue';
import { defineStore } from 'pinia';

export interface Cart {
    total: string;
    subtotal: string;
    empty: boolean;
    lines: CartLine[];
}

export interface CartLine {
    productId: number
    sku: string;
    name: string;
    total: string;
    subtotal: string;
    quantity: number;
}

export interface CartResponseData {
    cart: Cart;
}

export const useCartStore = defineStore('cartStore', () => {
    const data = ref<Cart | null>(null);

    async function fetch() {
        const response = await useNuxtApp().$siteFetch<CartResponseData>('/cart?format=json');

        if (response.cart) {
            data.value = response.cart;

            // Update the cart quantity in session storage
            if (typeof window !== 'undefined') {
                const cartQuantity = data.value?.lines?.reduce((acc, line) => acc + (line.quantity || 0), 0) || 0;
                window.sessionStorage.setItem("cartQuantity", cartQuantity.toString());
            }
        }

        return data.value;
    }

    function $reset() {
        data.value = null;
    }

    return { data, fetch, $reset };
});
